"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};
class ShowAuth extends _react.default.Component {
  render() {
    const {
      auth,
      children,
      ...rest
    } = this.props;
    return _react.default.cloneElement(children, {
      ...rest,
      auth: auth
    });
  }
}
ShowAuth.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: _propTypes.default.object,
  children: _propTypes.default.object
} : {};
var _default = exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(ShowAuth));
module.exports = exports.default;